import { Link, useLocation } from "react-router-dom";
import { LogIn, LayoutDashboard } from "lucide-react";
import { useMemberstack } from "@/lib/memberstack";

/**
 * Sticky brand header with The Weave logo, top-left.
 * Right side: context-aware auth link.
 *   • If signed in        → "Your dashboard" (hidden on /dashboard)
 *   • If signed out       → "Log in"          (hidden on /login)
 *   • Whilst loading auth → render nothing on the right (avoids flash)
 */
export default function SiteHeader({ onLogoClick }) {
  const { isAuthenticated, loading } = useMemberstack();
  const { pathname } = useLocation();

  const onLogin = pathname.startsWith("/login");
  const onDashboard = pathname.startsWith("/dashboard");

  const showLogin = !loading && !isAuthenticated && !onLogin;
  const showDashboard = !loading && isAuthenticated && !onDashboard;

  return (
    <header
      className="weave-site-header"
      data-testid="site-header"
      role="banner"
    >
      <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
        <button
          type="button"
          className="weave-logo-link"
          onClick={onLogoClick}
          aria-label="The Weave — go home"
          data-testid="site-logo-link"
        >
          <img
            src="/the-weave-logo.png"
            alt="The Weave"
            className="weave-logo-img"
          />
        </button>

        <div className="flex items-center gap-4">
          <span
            className="text-[11px] uppercase tracking-[0.22em] font-medium hidden md:inline"
            style={{ color: "#3c8386" }}
            data-testid="header-tagline"
          >
            An innovation tool by The Weave
          </span>

          {showLogin && (
            <Link
              to="/login"
              className="weave-header-link"
              data-testid="header-login-link"
            >
              <LogIn size={14} />
              <span>Log in</span>
            </Link>
          )}

          {showDashboard && (
            <Link
              to="/dashboard"
              className="weave-header-link"
              data-testid="header-dashboard-link"
            >
              <LayoutDashboard size={14} />
              <span className="hidden sm:inline">Your dashboard</span>
              <span className="sm:hidden">Dashboard</span>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
